var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.95,13.049v4.692c0,2.013-1.632,3.644-3.644,3.644H6.259c-2.013,0-3.644-1.632-3.644-3.644v-9.047c0-2.013,1.632-3.644,3.644-3.644h4.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.774,14.256l-4.544,1.978c-.293.127-.59-.17-.463-.463l1.978-4.544c.247-.568.599-1.085,1.038-1.524l6.363-6.363c.971-.971,2.545-.971,3.515,0h0c.971.971.971,2.545,0,3.515l-6.363,6.363c-.438.438-.955.79-1.524,1.038Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.268,10.307c.676.334,1.311.782,1.874,1.345.636.636,1.125,1.363,1.469,2.139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.652,13.737c.347.151.673.369.957.653s.502.61.653.958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f65839424834fb78829c485acebb65db.svg";
export { ForwardRef as ReactComponent };